export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx5_buy.72536944.mp3";